import React from "react";
import classNames from "classnames";
import * as c from "./lpAtAGlance.module.scss";
import IconCheckmark from "@components/icons/iconCheckmark";

const LpAtAGlance = ({ heading, listItems }) => {
  return (
    <section className={c.container} data-transition="slide-enter-child">
      <div className={c.content}>
        {heading && <h4 className={classNames(c.title, "h4")}>{heading}</h4>}

        <ul className={c.featuresGrid}>
          {listItems &&
            listItems.map((item) => (
              <li key={item} className={c.featureItem}>
                <span className={c.checkIcon}>
                  <IconCheckmark />
                </span>
                <p className={classNames(c.featureText, "p3")}>{item}</p>
              </li>
            ))}
        </ul>
      </div>
    </section>
  );
};

export default LpAtAGlance;
